import React from "react";
import PropTypes from "prop-types";

import {classNames} from "../../../utils/Utils";
import {FALLBACK_VALUE, getDisplayValue} from "./document-header-utils";

const Field = ({label, value, className}) => (
    <div className={classNames("py-0.5", className)}>
        <p className="text-[11px] font-semibold uppercase tracking-wide text-blue-1000">{label}</p>
        <p className="mt-0.5 text-sm text-gray-900" title={getDisplayValue(value)}>
            {getDisplayValue(value)}
        </p>
    </div>
);

Field.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node,
    ]),
    className: PropTypes.string,
};

Field.defaultProps = {
    value: FALLBACK_VALUE,
    className: "",
};

export default Field;
